<template>
  <div class="publicSearchBox">
    <ul>
      <li>
        <div class="text title">选择工种</div>
        <div class="textBox worker-group">
          <el-radio-group v-model="category" @change="chanWorkType">
            <el-radio-button
              :class="item.active ? 'active-label':''"
              v-for="item in categoryList" :label="item.id" class="text"
              v-if="item.shortName !== '其他' && item.name !== '热门工种'"
              :key="item.id">{{ item.active ? item.shortName + '·' + item.num : item.shortName }}
            </el-radio-button>
          </el-radio-group>

          <div class="border" v-if="workTypeList.length > 0">
            <el-checkbox-group v-model="workTypeValueList" @change="selectWorkType">
              <el-checkbox-button v-for="item in workTypeList" :label="item.id" :key="item.id">{{ item.name }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
      </li>

      <li>
        <div class="text title">工作省份</div>
        <div class="textBox province-group">
          <el-radio-group v-model="province" @change="changeProvince">
            <el-radio-button
              :class="item.active ? 'active-label':''"
              v-for="item in provinceList" :label="item.id" class="text"
              :key="item.id">{{ item.active ? item.shortName + '·' + item.num : item.shortName }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </li>

      <li v-if="cityList.length > 0">
        <div class="text title">工作城市</div>
        <div class="textBox city-group">
          <div v-if="cityList.length > 0">
            <el-checkbox-group v-model="cityValueList" @change="selectCity">
              <el-checkbox-button v-for="item in cityList" :label="item.id" :key="item.id">
                {{ item.shortName }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
      </li>

      <li>
        <div class="text title">发布时间</div>
        <div class="textBox">
          <el-radio-group v-model="pubDay" @change="changePubDay">
            <el-radio-button class="text" v-for="item in pubDayList" :label="item.id"
                             :key="item.id">{{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  getPubDay,
  selectProvinceList,
  selectCitiesByProvinceId,
  selectByCondition,
  selectCategoryList
} from '@api/public'

export default {
  name: 'searchBox',
  props: ['categoryId', 'workTypeId'],
  data() {
    return {
      category: '',
      categoryList: [], // 一级工种list
      workTypeList: [], // 二级工种list
      workType: [], // 选中的一级工种id
      workTypeValueList: [], // 选中的二级工种id list

      provinceList: [], // 一级工作城市list
      cityList: [], // 二级工作城市list
      province: '', // 选中的一级城市id
      cityValueList: [],// 选中的二级城市id  list

      pubDayList: [], // 发布时间list
      pubDay: '0', // 选中的发布时间

      cityJson: {
        cityId: '320500',
        cityName: '苏州市'
      },
    }
  },
  created() {
    this.getPubDay()
    this.selectProvinceList()
    this.selectCategoryList()

    if (this.categoryId && this.workTypeId) {
      this.category = this.categoryId
      this.workTypeValueList = [this.workTypeId]

      setTimeout(() => {
        this.selectWorkers(this.categoryId, true)
      }, 200)
    }

    // 初次渲染城市
    if (localStorage.getItem('ygw-city')) {
      this.cityJson = JSON.parse(localStorage.getItem('ygw-city'))
    }

    this.cityValueList = [this.cityJson.cityId]

    setTimeout(() => {
      this.province = this.cityJson.cityId.slice(0, 2) + '0000'
      this.selectCitiesByProvinceId(this.cityJson.cityId.slice(0, 2) + '0000', true)
    }, 200)

  },

  mounted() {
    this.$forceUpdate()
  },
  methods: {

    // 渲染工种
    initCategory(data, first) {
      if (data.length === 0) {
        for (let i = 0; i < this.categoryList.length; i++) {
          this.categoryList[i].active = false
          this.categoryList[i].num = 0
        }
        this.$forceUpdate()
        return
      }

      let categoryId = ''
      let num = 0

      if (first) {
        num = 1
        categoryId = data[0]
      } else {
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < this.workTypeList.length; j++) {
            if (data[i] == this.workTypeList[j].id) {
              num++
              categoryId = this.workTypeList[j].categoryId
              break
            }
          }
        }
      }

      if (num === 0) {
        for (let i = 0; i < this.categoryList.length; i++) {
          if (this.category == this.categoryList[i].id) {
            this.categoryList[i].active = false
            this.categoryList[i].num = num
            break
          }
        }
      } else {
        for (let i = 0; i < this.categoryList.length; i++) {
          if (categoryId == this.categoryList[i].id) {
            this.categoryList[i].active = true
            this.categoryList[i].num = num
            break
          }
        }
      }

      this.$forceUpdate()
    },

    // 渲染城市
    initProvince(data, first) {

      if (data.length === 0) {
        for (let i = 0; i < this.provinceList.length; i++) {
          this.provinceList[i].active = false
          this.provinceList[i].num = 0
        }
        this.$forceUpdate()
        return
      }

      let provinceId = ''
      let num = 0

      if (first) {
        num = 1
        provinceId = data[0].slice(0, 2) + '0000'
      } else {
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < this.cityList.length; j++) {
            if (data[i] == this.cityList[j].id) {
              num++
              provinceId = this.cityList[j].id.slice(0, 2) + '0000'
              break
            }
          }
        }
      }

      if (num === 0) {
        for (let i = 0; i < this.provinceList.length; i++) {
          if (this.province == this.provinceList[i].id) {
            this.provinceList[i].active = false
            this.provinceList[i].num = num
            break
          }
        }
      } else {
        for (let i = 0; i < this.provinceList.length; i++) {
          if (provinceId == this.provinceList[i].id) {
            this.provinceList[i].active = true
            this.provinceList[i].num = num
            break
          }
        }
      }

      this.$forceUpdate()
    },

    // 获取发布时间
    getPubDay() {
      getPubDay().then(res => {
        if (res.data.code === 200) {
          let pubDayList = [{
            id: '0',
            name: '全部'
          }]
          this.pubDayList = pubDayList.concat(res.data.data)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    selectProvinceList() {
      selectProvinceList().then(res => {
        if (res.data.code === 200) {
          let provinceList = [{id: -1, shortName: '全国'}]
          this.provinceList = provinceList.concat(res.data.data.provinces)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeProvince(code) {
      if (code === -1) {

        this.initProvince([])

        this.cityList = []
        this.cityValueList = []
        const query = {
          cityValueList: []
        }
        this.$emit('searchList', query)
        return
      }
      this.selectCitiesByProvinceId(code)
    },
    // 获取省下面的市
    selectCitiesByProvinceId(code, first) {
      selectCitiesByProvinceId({provinceId: code}).then(res => {
        if (res.data.code === 200) {
          this.cityList = res.data.data
          if (first) {
            this.initProvince([this.cityJson.cityId], true)
          }
          this.$forceUpdate()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取所有工种分类
    selectCategoryList() {
      selectCategoryList().then(res => {
        if (res.data.code === 200) {
          let categoryList = [{id: -1, shortName: '全部工种'}]
          this.categoryList = categoryList.concat(res.data.data)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 点击一级工种
    chanWorkType(code) {
      if (code === -1) {
        this.initCategory([])

        this.workTypeList = []
        this.workTypeValueList = []
        const query = {
          workTypeValueList: []
        }
        this.$emit('searchList', query)
        return
      }
      this.selectWorkers(code)
    },

    // 根据工种分类获取工种
    selectWorkers(code, first) {
      selectByCondition({categoryId: code}).then(res => {
        if (res.data.code === 200) {
          this.workTypeList = res.data.data

          if (first) {
            this.initCategory([code], true)
          }
          this.$forceUpdate()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 点击发布时间
    changePubDay(data) {
      const query = {
        pubDay: data
      }
      this.$emit('searchList', query)
    },
    // 点击城市
    selectCity(data) {

      // 判断选取为省，取消省下的市
      if (data.length > 0) {
        let strLs = data[data.length - 1].substring(2, 6)
        if (strLs === '0000') {
          let strSan = data[data.length - 1].substring(0, 2)
          for (let i = 0; i < data.length - 1; i++) {
            if (strSan == data[i].substring(0, 2)) {
              let index = data.indexOf(data[i])
              if (index > -1) {
                i--
                data.splice(index, 1)
              }
            }
          }
        } else {
          let strSan = data[data.length - 1].substring(0, 2) + '0000'
          // let strSan = data[data.length - 1].substring(0, 2)
          for (let i = 0; i < data.length - 1; i++) {
            if (strSan == data[i]) {
              let index = data.indexOf(data[i])
              if (index > -1) {
                i--
                data.splice(index, 1)
              }
            }
          }
        }
      }

      if (data.length > 5) {
        this.cityValueList = this.cityValueList.slice(0, 5)
        this.$message.warning('最多选择5个城市')
        return false
      }

      this.initProvince(data)

      this.cityValueList = data
      const query = {
        cityValueList: data
      }
      this.$emit('searchList', query)
    },
    // 选择工种
    selectWorkType(data) {
      if (data.length > 5) {
        this.workTypeValueList = this.workTypeValueList.slice(0, 5)
        this.$message.warning('最多选择5个工种')
        return false
      }

      this.initCategory(data)

      this.workTypeValueList = data
      const query = {
        workTypeValueList: data
      }
      this.$emit('searchList', query)
    },
  }
}
</script>

<style lang="scss">
.publicSearchBox {
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 6px 20px 1px 20px;
  background: #fff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);

  .worker-group {
    .el-radio-button {
      width: 97px;
      margin-right: 0;
    }
  }

  .province-group {
    .el-radio-button {
      width: 66px;
      margin-right: 0;
    }
  }

  .el-radio-button__inner:hover {
    color: #63A1F4FF;
  }

  .active-label {
    .el-radio-button__inner {
      font-weight: bold;
      color: #63a1f4;
    }
  }

  ul {
    margin-top: 18px;

    li {
      display: flex;
      align-items: flex-start;
      margin-bottom: 14px;

      .title {
        color: #333333;
        margin-right: 32px;
        width: 62px;
        font-weight: bold;
        font-size: 16px;
        margin-top: -2px;
      }

      .text {
        font-size: 14px;
        display: inline-block;
      }

      i {
        color: #999;
        font-size: 14px;
        vertical-align: text-top;
      }

      .textBox {
        width: calc(100% - 40px);

        .text {
          cursor: pointer;
        }
      }

      .el-radio-button__inner {
        border: none;
        font-size: 14px;
        color: #333;
        padding: 0;
      }

      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #fff;
        color: #0368C1;
        border: none;
      }

      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        box-shadow: none;
      }

      .el-radio-button:first-child .el-radio-button__inner {
        border: none;
      }

      .el-checkbox-button__inner {
        border: none;
        font-size: 14px;
        padding: 0;
      }

      .el-checkbox-button.is-checked .el-checkbox-button__inner {
        background-color: #fff;
        color: #0368C1;
        border: none;
      }

      .el-checkbox-button.is-checked .el-checkbox-button__inner {
        box-shadow: none;
      }

      .el-checkbox-button:first-child .el-checkbox-button__inner {
        border: none;
      }

      .el-radio-button {
        margin-right: 28px;
        margin-bottom: 15px;
      }

      .el-checkbox-button {
        margin-right: 28px;
        margin-bottom: 15px;
      }
    }
  }

  .border {
    border-top: 1px solid #eee;
    padding-top: 16px;
  }
}
</style>
